/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import './CodeRendererStyles.scss';
const baseClass = 'qmb-ui-code-renderer';
export function CodeRenderer({ block }) {
    const codeBlock = block;
    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(codeBlock.content).catch(Function.prototype);
    }, [codeBlock.content]);
    const footerGroups = codeBlock.copyable
        ? [{ actions: [{ id: 'copy', label: 'Copy', icon: 'fa-light fa-copy', onClick: handleCopy }] }]
        : [];
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: codeBlock.title,
                content: (React.createElement("div", { className: baseClass },
                    React.createElement("pre", { className: `${baseClass}__pre` },
                        React.createElement("code", { className: `${baseClass}__code language-${codeBlock.language}` }, codeBlock.content))))
            }
        ], footerGroups: footerGroups }));
}
